@if (imageUrl) {
  <img [src]="imageUrl" [ngClass]="classes" [style.border-radius]="shape === 'rounded' ? '18px' : '50%'" alt="{{ fullName }}" />
} @else {
  <div [ngClass]="classes" [style.background]="getAvatarColor()" [style.box-shadow]="getRingBoxShadow()">{{ getInitials() }}</div>
}
